<style lang="scss" src="./SolicitudesRevisadasTabla.scss"></style>
<template src="./SolicitudesRevisadasTabla.html"></template>

<script>
import {Pagination, Table, TableColumn, Tooltip, Divider, Tag} from 'element-ui';
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi";
import {requestRevisionMixin} from "@/api/partidoPolitico/revisionApi";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import moment from "moment";
import {TableMixin} from "@/mixins/TableMixin";
import {utils} from "@/utils";
import ToolbarSearch from "@/components/Shared/ToolbarSearch/ToolbarSearch";
import {ActividadCiudadanoEstadoMixin} from "@/mixins/actividadCiudadanoEstado";

export default {
  name: "SolicitudesRevisadasTabla",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Tooltip.name]: Tooltip,
    [Divider.name]: Divider,
    [Tag.name]: Tag,
    ToolbarSearch
  },
  mixins: [requestAfiliacionMixin,
    requestRevisionMixin,
    ScreenSizeMixin,
    NotifyMixin,
    TableMixin,
    ActividadCiudadanoEstadoMixin
  ],
  data() {
    return {
      pickerOptFilterDate: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      listSelection: [],
      isSelect: false,
    }
  },
  beforeMount() {
    const pagingQuery = {
      currentPage: this.pagination.currentPage,
      pageSize: this.pagination.pageSize,
    }
    this.getList(pagingQuery, true);
  },
  methods: {
    getList(pagingQuery = {}, firstTime = false) {
      this.loading = true;
      pagingQuery['compress'] = false
      pagingQuery['fields'] = ['id', 'run', 'nombres', 'paterno', 'materno', 'fechanacimiento', 'region', 'comuna', 'domicilio', 'fechacompleta', 'tipo_afiliacion', 'estado', 'codigoestado']

      this.listaRevision(pagingQuery)
        .then(response => {
          this.$log.debug('listaRevision', response.data.statusCode)

          if (response.data.statusCode === 200) {
            this.pagination.total = response.data.totalItems
            const data = JSON.parse(response.data.datos);

            this.tableData = data.map(row => {
              row.fechacompleta = moment.utc(row.fechacompleta).local().format('DD-MM-YYYY HH:mm')
              row.run = utils.rutFilter(row.run)
              return row
            })
            this.$log.debug(this.tableData)

            this.errored = false;
            if (this.tableData.length === 0) {
              if (firstTime) {
                this.showError('No hay solicitudes revisadas para su partido político, puede presionar el botón refrescar si lo desea.')
              } else {
                this.showWarn('No hay solicitudes revisadas con sus filtros, puede presionar el botón refrescar si lo desea.')
              }
            }
            this.$scrollTo('#solicitudesRevisadasTable')
          } else {
            this.errored = true
            this.showError('Ocurrió un error inesperado al cargar los datos')
          }
        }).catch(err => {
        this.$log.fatal('listaRevision', err, err.response, err.request)
        this.errored = true
        this.showError('Ocurrió un error inesperado al cargar los datos')
      })
        .finally(() => {
          this.loading = false
        })
    },
    verSolicitud(id) {
      this.$log.debug('onVerSolicitud', id)
      this.$emit('on-ver-solicitud', id)
    },
    checkSelection() {
      this.$log.debug('onCheckSelection', this.listSelection)
      this.$emit('on-check-selection', this.listSelection)
    },
    checkAll() {
      this.$log.debug('onCheckall', this.tableData)
      this.$emit('on-check-all', this.tableData)
    },
  },
  computed: {
    perPage() {
      if (this.parametro.params)
        return parseInt(this.parametro.params.solicitudrevisadapaginacion)
      return 10
    },

  },
}
</script>
